// import React from 'react';
// import { Linkedin, Twitter, Mail } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';
// import nrImage from  "./assets/office.jpeg" 
// export const Attorneys = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });
//   const attorneys = [
//     {
//       name: 'أ. ناصر الراجحي',
//       position: '   شريك مؤسس ',
//       specialization: 'القانون التجاري والتحكيم',
//       image:nrImage,


//       bio: 'خبرة أكثر من 20عاماً في مجال القانون التجاري والتحكيم'    
    
    
    
//     },
//      {
//       name: 'أ. رامي  المطيري',
//       position: '   شريك مؤسس ',
//       specialization: 'نظام العمل و حوكمة الشركات ',

//       image:nrImage,
//       bio: 'خبرة اكثر من 15 عاما في قضايا نظام العمل وحوكمة الشركات '
//     },
//     {
//       name: 'أ. فهد الغانمي',
//       position: 'شريك و مدير ',
//       specialization: 'القانون التجاري و نظام العمل ',
//       image:nrImage,
//       bio: 'متخصص في قضايا العقارات والإيجارات وحل النزاعات المدنية بخبرة تزيد عن 7+ أعوام',
//     },
    
//     {
//  name: 'أ. سعيد أبو زيد',
//       position: 'مستشار قانوني',
//       specialization: 'الشركات  و القانون المدني',
//       image:nrImage,
//       bio: '      متخصص في قضايا   الشركات و القانون المدني',
//     },
//     {
//       name: 'أ. رغد الصبياني',
//       position: 'محامية ',
//       specialization: 'قانون الشركات و الإفلاس  و القانون المدني',
//       image:nrImage,
//       bio: 'متخصصة في قضايا الأحوال الشخصية والأسرة وحقوق المرأة مع خبرة تزيد عن 5+ أعوام',
//     },

//     {
//  name: 'أ. محمد المخلفي',
//       position: 'محامي',
//       specialization: 'قانون التنفيذ والقانون المدني',
//       image:nrImage,

//  bio: 'متخصص في قضايا قانون التنفيذ و القانون المدني بخبرة  تزيد عن 6 أعوام ',    },
//     {
//  name: 'أ. رقيان البقمي',
//       position: 'محامي',
//       specialization: 'نظام العمل و المقاولات ',
//       image:nrImage,
//  bio: 'متخصص في قضايا نظام العمل والمقاولات ',    },
//     {
//  name: 'أ. جمانة السيد',
//       position: 'محامية',
//       specialization: 'القانون الإداري  والقانون المدني',
//       image:nrImage,
//  bio: 'متخصصة في قضايا القانون الإداري وقضايا المساهمات العقارية ',    },
//     {
//  name: 'أ. البدور عشقان',
//       position: 'محامية',
//       specialization: 'الشركات و القانون المدني',
//       image:nrImage,
//       bio: 'متخصصة في قضايا الأحوال الشخصية والشركات ',
//     }
   
//   ];

//   return (
//     <section id="attorneys" className="py-20 bg-white">
//       <div className="container mx-auto px-4 md:px-6">
//         <div 
//           ref={ref}
//           className={`text-center mb-16 transform transition-all duration-700 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">فريق المحامين</h2>
//           <div className="w-24 h-1 bg-gold-500 mx-auto mb-6"></div>
//           <p className="text-lg text-gray-700 max-w-3xl mx-auto">
//             يضم مكتبنا نخبة من المحامين المتخصصين بخبرات واسعة في مختلف مجالات القانون
//           </p>
//         </div>
        
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {attorneys.map((attorney, index) => (
//             <div 
//               key={index}
//               className={`bg-white rounded-lg overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 transform hover:-translate-y-2 ${
//                 inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
//               }`}
//               style={{ 
//                 transitionDelay: `${index * 100}ms`,
//                 opacity: inView ? 1 : 0,
//                 transform: inView ? 'translateY(0)' : 'translateY(20px)'
//               }}
//             >
//               <div className="h-64 relative overflow-hidden">
//                 <img 
//                   src={attorney.image} 
//                   alt={attorney.name} 
//                   className="w-full h-full object-cover object-center transition-transform duration-500 hover:scale-110"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-navy-900 to-transparent opacity-70"></div>
//                 <div className="absolute bottom-0 right-0 left-0 p-4 text-white">
//                   <h3 className="text-xl font-bold mb-1">{attorney.name}</h3>
//                   <p className="text-gold-500 font-medium text-sm">{attorney.position}</p>
//                 </div>
//               </div>
              
//               <div className="p-5">
//                 <div className="mb-3">
//                   <span className="inline-block bg-navy-100 text-navy-900 px-3 py-1 rounded-full text-sm font-medium">
//                     {attorney.specialization}
//                   </span>
//                 </div>
//                 <p className="text-gray-700 mb-4">{attorney.bio}</p>
                
//                 {/* <div className="flex justify-center space-x-4 rtl:space-x-reverse">
//                   <button className="text-navy-900 hover:text-gold-500 transition-colors duration-300">
//                     <Linkedin className="h-5 w-5" />
//                   </button>
//                   <button className="text-navy-900 hover:text-gold-500 transition-colors duration-300">
//                     <Twitter className="h-5 w-5" />
//                   </button>
//                   <button className="text-navy-900 hover:text-gold-500 transition-colors duration-300">
//                     <Mail className="h-5 w-5" />
//                   </button>
//                 </div> */}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// import React from 'react';
// import { Linkedin, Twitter, Mail } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';
// import nrImage from "./assets/office.jpeg";

// export const Attorneys = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.05,
//     triggerOnce: true,
//   });

//   const attorneys = [
//     {
//       name: 'أ. ناصر الراجحي',
//       position: 'شريك مؤسس',
//       specialization: 'القانون التجاري والتحكيم',
//       image: nrImage,
//       bio: ' خبرة تمتد لأكثر من عشرون عاماً في مجال المحاماة والإستشارات القانونية ، خبير ومحكم معتمد',
//     },
//     {
//       name: 'أ. رامي المطيري',
//       position: 'شريك مؤسس',
//       specialization: 'نظام العمل وحوكمة الشركات',
//       image: nrImage,
//       bio:'خبرة قانونية تمتد لأكثر من خمسة عشر عاماً في مجال المحاماة والاستشارات القانونية، مختص في حوكمة الشركات وإدارة أعمالها القانونية '
//     },
//     {
//       name: 'أ. فهد الغانمي',
//       position: 'شريك ومدير',
//       specialization: 'القانون التجاري ونظام العمل',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لأكثر من سبعة سنوات في مجال الترافع أمام المحاكم في مختلف درجاتها ، مختص في إدارة العمليات القانونية'
//     },
//     {
//       name: 'أ. سعيد أبو زيد',
//       position: 'مستشار قانوني',
//       specialization: 'الشركات والقانون المدني',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لأكثر من 8 أعوام في الصياغة القانونية وأنظمة وزارة الموارد البشرية'
//     },
//     {
//       name: 'أ. رغد الصبياني',
//       position: 'محامية',
//       specialization: 'قانون الشركات والإفلاس والقانون المدني',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لأكثر من خمسة سنوات في المجال الأكاديمي والمهني ، مختصة أعمال الشركات بالشركة'
//     },
//     {
//       name: 'أ. محمد المخلفي',
//       position: 'محامي',
//       specialization: 'قانون التنفيذ والقانون المدني',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لأكثر من سبعة سنوات في الترافع أمام المحاكم واللجان القضائية  ، مختص في إدارة العمليات القانونية'
//     },
//     {
//       name: 'أ. رقيان البقمي',
//       position: 'محامي',
//       specialization: 'نظام العمل والمقاولات',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لأكثر من ثلاثة سنوات في مجال المحاماة والاستشارات القانونية ، مختص في قضايا المقاولات بالشركة'
//     },
//     {
//       name: 'أ. جمانة السيد',
//       position: 'محامية',
//       specialization: 'القانون الإداري والقانون المدني',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لأكثر من أربعة سنوات في مجال المحاماة والاستشارات القانونية ، مختصة في القضاء الإداري بالشركة '
//     },
//     {
//       name: 'أ. البدور عشقان',
//       position: 'محامية',
//       specialization: 'الشركات والقانون المدني',
//       image: nrImage,
//       bio: 'خبرة قانونية تمتد لقرابة العام في المجال القانوني بالشركة'
//     }
//   ];

//   return (
//     <section id="attorneys" className="py-24 bg-slate-905 bg-slate-900 border-b border-slate-800" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
//         {/* ترويسة القسم */}
//         <div 
//           ref={ref}
//           className={`text-center mb-20 transform transition-all duration-1000 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
//             فريق <span className="text-amber-400">العمل</span>
//           </h2>
//           <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-amber-300 mx-auto mb-6 rounded-full"></div>
//           <p className="text-base md:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
//             يضم مكتبنا نخبة متكاملة من المحامين والمستشارين المتخصصين، يجمعهم الشغف والخبرة العميقة لتقديم الحماية القانونية المطلقة لأعمالكم.
//           </p>
//         </div>
        
//         {/* شبكة عرض بطاقات مستشاري ومحامي المكتب */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 xl:gap-10">
//           {attorneys.map((attorney, index) => (
//             <div 
//               key={index}
//               className={`group bg-slate-950/50 rounded-2xl overflow-hidden border border-slate-800/80 shadow-xl transition-all duration-500 transform hover:-translate-y-2 hover:border-amber-500/20 flex flex-col justify-between ${
//                 inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
//               }`}
//               style={{ 
//                 transitionDelay: `${index * 50}ms`,
//               }}
//             >
//               {/* صورة المحامي والاسم والمنصب عبر طبقة علوية */}
//               <div className="h-72 relative overflow-hidden bg-slate-950">
//                 <img 
//                   src={attorney.image} 
//                   alt={attorney.name} 
//                   className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105 filter brightness-90 group-hover:brightness-100"
//                   loading="lazy"
//                 />
//                 {/* تدرج ظلي ناعم من الخلفية المظلمة لإبراز النصوص الفاتحة */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent opacity-90 group-hover:opacity-85 transition-opacity duration-300"></div>
                
//                 <div className="absolute bottom-0 right-0 left-0 p-5 text-right">
//                   <h3 className="text-xl md:text-2xl font-bold text-white mb-1 transition-colors duration-300 group-hover:text-amber-400">
//                     {attorney.name}
//                   </h3>
//                   <p className="text-amber-400 font-medium text-xs md:text-sm tracking-wide">
//                     {attorney.position}
//                   </p>
//                 </div>
//               </div>
              
//               {/* تفاصيل التخصص والسيرة المهنية المختصرة */}
//               <div className="p-6 flex-grow flex flex-col justify-between bg-slate-950/20">
//                 <div>
//                   <div className="mb-4">
//                     <span className="inline-block bg-amber-500/10 text-amber-400 border border-amber-500/10 px-3 py-1 rounded-lg text-xs font-semibold">
//                       {attorney.specialization}
//                     </span>
//                   </div>
//                   <p className="text-slate-300 text-sm md:text-base leading-relaxed font-light mb-6">
//                     {attorney.bio}
//                   </p>
//                 </div>
                
//                 {/* قنوات التواصل الرسمية مبرمجة بجمالية فخمة */}
//                 <div className="flex items-center gap-4 pt-4 border-t border-slate-800/60 justify-end">
//                   <a href="#" className="text-slate-400 hover:text-amber-400 transition-colors duration-200 p-1" aria-label={`LinkedIn - ${attorney.name}`}>
//                     <Linkedin className="h-4 w-4" />
//                   </a>
//                   <a href="#" className="text-slate-400 hover:text-amber-400 transition-colors duration-200 p-1" aria-label={`Twitter - ${attorney.name}`}>
//                     <Twitter className="h-4 w-4" />
//                   </a>
//                   <a href={`mailto:info@nrfirm.com?subject=إلى ${attorney.name}`} className="text-slate-400 hover:text-amber-400 transition-colors duration-200 p-1" aria-label={`Email - ${attorney.name}`}>
//                     <Mail className="h-4 w-4" />
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

import React from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import nrImage from "./assets/office.jpeg";

export const Attorneys = () => {
  const { ref, inView } = useInView({
    threshold: 0.05,
    triggerOnce: true,
  });

  const attorneys = [
    {
      name: 'أ. ناصر الراجحي',
      position: 'شريك مؤسس',
      specialization: 'القانون التجاري والتحكيم',
      image: nrImage,
      bio: ' خبرة تمتد لأكثر من عشرون عاماً في مجال المحاماة والإستشارات القانونية ، خبير ومحكم معتمد',
    },
    {
      name: 'أ. رامي المطيري',
      position: 'شريك مؤسس',
      specialization: 'نظام العمل وحوكمة الشركات',
      image: nrImage,
      bio:'خبرة قانونية تمتد لأكثر من خمسة عشر عاماً في مجال المحاماة والاستشارات القانونية، مختص في حوكمة الشركات وإدارة أعمالها القانونية '
    },
    {
      name: 'أ. فهد الغانمي',
      position: 'شريك ومدير',
      specialization: 'القانون التجاري ونظام العمل',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لأكثر من سبعة سنوات في مجال الترافع أمام المحاكم في مختلف درجاتها ، مختص في إدارة العمليات القانونية'
    },
    {
      name: 'أ. سعيد أبو زيد',
      position: 'مستشار قانوني',
      specialization: 'الشركات والقانون المدني',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لأكثر من 8 أعوام في الصياغة القانونية وأنظمة وزارة الموارد البشرية'
    },
    {
      name: 'أ. رغد الصبياني',
      position: 'محامية',
      specialization: 'قانون الشركات والإفلاس والقانون المدني',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لأكثر من خمسة سنوات في المجال الأكاديمي والمهني ، مختصة أعمال الشركات بالشركة'
    },
    {
      name: 'أ. محمد المخلفي',
      position: 'محامي',
      specialization: 'قانون التنفيذ والقانون المدني',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لأكثر من سبعة سنوات في الترافع أمام المحاكم واللجان القضائية  ، مختص في إدارة العمليات القانونية'
    },
    {
      name: 'أ. رقيان البقمي',
      position: 'محامي',
      specialization: 'نظام العمل والمقاولات',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لأكثر من ثلاثة سنوات في مجال المحاماة والاستشارات القانونية ، مختص في قضايا المقاولات بالشركة'
    },
    {
      name: 'أ. جمانة السيد',
      position: 'محامية',
      specialization: 'القانون الإداري والقانون المدني',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لأكثر من أربعة سنوات في مجال المحاماة والاستشارات القانونية ، مختصة في القضاء الإداري بالشركة '
    },
    {
      name: 'أ. البدور عشقان',
      position: 'محامية',
      specialization: 'الشركات والقانون المدني',
      image: nrImage,
      bio: 'خبرة قانونية تمتد لقرابة العام في المجال القانوني بالشركة'
    }
  ];

  return (
    // ضبط الخلفية للون الرمادي الخفيف المتناسق مع الوضع الفاتح النظيف
    <section id="attorneys" className="py-24 bg-slate-50 border-b border-slate-200" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* ترويسة القسم */}
        <div 
          ref={ref}
          className={`text-center mb-20 transform transition-all duration-1000 ${
            inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4">
            فريق <span className="text-indigo-950">العمل</span>
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-indigo-950 to-blue-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-base md:text-xl text-black max-w-3xl mx-auto leading-relaxed font-light">
            يضم مكتبنا نخبة متكاملة من المحامين والمستشارين المتخصصين، يجمعهم الشغف والخبرة العميقة لتقديم الحماية القانونية المطلقة لأعمالكم.
          </p>
        </div>
        
        {/* شبكة عرض بطاقات مستشاري ومحامي المكتب بخلفيات بيضاء ناصعة */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 xl:gap-10">
          {attorneys.map((attorney, index) => (
            <div 
              key={index}
              className={`group bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-md transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl flex flex-col justify-between ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ 
                transitionDelay: `${index * 50}ms`,
              }}
            >
              {/* صورة المحامي والاسم والمنصب عبر طبقة علوية مع لمسات فاتحة فاخرة */}
              <div className="h-72 relative overflow-hidden bg-slate-100">
                <img 
                  src={attorney.image} 
                  alt={attorney.name} 
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                {/* تدرج ظلي أبيض ناعم في الأسفل لإبراز النصوص الكحلية بشكل ناصع وواضح */}
                <div className="absolute inset-0 bg-gradient-to-t from-white via-white/20 to-transparent opacity-95 group-hover:opacity-90 transition-opacity duration-300"></div>
                
                <div className="absolute bottom-0 right-0 left-0 p-5 text-right">
                  <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-1 transition-colors duration-300 group-hover:text-indigo-950">
                    {attorney.name}
                  </h3>
                  <p className="text-indigo-950 font-semibold text-xs md:text-sm tracking-wide">
                    {attorney.position}
                  </p>
                </div>
              </div>
              
              {/* تفاصيل التخصص والسيرة المهنية المختصرة */}
              <div className="p-6 flex-grow flex flex-col justify-between bg-white">
                <div>
                  <div className="mb-4">
                    {/* شارة التخصص الكحلية الناعمة المتطابقة مع النمط الجديد */}
                    <span className="inline-block bg-indigo-50 text-indigo-950 border border-indigo-100/50 px-3 py-1 rounded-lg text-xs font-semibold">
                      {attorney.specialization}
                    </span>
                  </div>
                  <p className="text-black text-sm md:text-base leading-relaxed font-light mb-6">
                    {attorney.bio}
                  </p>
                </div>
                
                {/* قنوات التواصل الرسمية مبرمجة بجمالية كحلية فخمة */}
                <div className="flex items-center gap-4 pt-4 border-t border-slate-100 justify-end">
                  <a href="#" className="text-slate-400 hover:text-indigo-950 transition-colors duration-200 p-1" aria-label={`LinkedIn - ${attorney.name}`}>
                    <Linkedin className="h-4 w-4" />
                  </a>
                  <a href="#" className="text-slate-400 hover:text-indigo-950 transition-colors duration-200 p-1" aria-label={`Twitter - ${attorney.name}`}>
                    <Twitter className="h-4 w-4" />
                  </a>
                  <a href={`mailto:info@nrfirm.com?subject=إلى ${attorney.name}`} className="text-slate-400 hover:text-indigo-950 transition-colors duration-200 p-1" aria-label={`Email - ${attorney.name}`}>
                    <Mail className="h-4 w-4" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};